import React, { useRef } from "react";
import Header from "components/home/Header";
import Features from "components/home/Features";
import Navbar from "components/navigation/Navbar";
import Footer from "components/navigation/Footer";
import useSmoothSectionScroll from "../../hooks/useSmoothSnapScroll";

function Home() {
  const scrollContainerRef = useRef(null);
  const featuresRef = useRef(null);

  useSmoothSectionScroll(scrollContainerRef);

  const scrollToFeatures = () => {
    featuresRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      ref={scrollContainerRef}
      className="h-screen overflow-y-scroll scroll-smooth snap-y snap-mandatory"
    >
      {/* Section 1: Navbar + Hero */}
      <section className="h-screen snap-start relative">
        <Navbar scrollContainerRef={scrollContainerRef} />
        <Header onScrollDown={scrollToFeatures} />
      </section>

      {/* Section 2: Features */}
      <section
        ref={featuresRef}
        id="features-section"
        className="min-h-screen snap-start"
      >
        <Features />
        <Footer scrollRef={scrollContainerRef} />
      </section>
    </div>
  );
}

export default Home;
